/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const headerProvisionalConfig = {
  headerTitle: 'Provisional Policies',
  headerDescription: '',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
  csvButton: {
    id: 'csvDownload',
    label: 'Download CSV',
    icon: 'DownloadIcon',
    fileName: 'provisional-policies',
    headers: [
      {
        label: 'Policy Holder',
        key: 'name',
      },
      {
        label: 'Policy Holder Email',
        key: 'email',
      },
      {
        label: 'Policy Number',
        key: 'policyNo',
      },
      {
        label: 'Policy Option',
        key: 'policyOption',
      },
      {
        label: 'Policy Coverage',
        key: 'coverage',
      },
      {
        label: 'Policy Premium',
        key: 'premium',
      },
      {
        label: 'Discounted Premium',
        key: 'discount',
      },
      {
        label: 'Date Purchased',
        key: 'dateCreated',
      },
      {
        label: 'Insured Country',
        key: 'country',
      },
    ],
  },
};
